import { useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";

const formats = ["w-4 h-4 mx-0.5", "w-3 h-5 mx-1", "w-5 h-3", "w-5 h-5"];
export const FormatIcon = ({ format }: { format: string }) => {
  const [formatClass, setFormatClass] = useState(formats[0]);
  const intervalRef = useRef<any>(0);
  const animatedIndex = useRef(0);

  useEffect(() => {
    if (format === "auto") {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        animatedIndex.current = (animatedIndex.current + 1) % formats.length;
        setFormatClass(formats[animatedIndex.current]);
      }, 800);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      () => clearInterval(intervalRef.current);
    } else {
      clearInterval(intervalRef.current);
      switch (format) {
        case "auto":
          setFormatClass(formats[0]);
          break;
        case "portrait":
          setFormatClass(formats[1]);
          break;
        case "landscape":
          setFormatClass(formats[2]);
          break;
        case "square":
          setFormatClass(formats[0]);
          break;
      }
    }
  }, [format]);

  return (
    <>
      <div
        className={twMerge(
          formatClass,
          format === "auto" && "transition-all duration-200",
          "border-2 dark:border-white"
        )}
      />
    </>
  );
};
